import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

/**
 * NEW BOOKING SYSTEM - BOOKING SLOT TIME BUTTON COMPONENT
 * 
 * This component displays individual booking slots as clickable time buttons
 * in the company booking interface. It shows the time, duration, and price
 * for each available slot.
 */

const BookingSlotTimeButton = ({
  bookingSlot,
  isSelected,
  onSelect,
  serviceIndex,
  setItem,
  setSelectedServiceIndex,
  executeScrollForm,
  activeIndex,
  bookingItemTime
}) => {
  const { start_time, end_time, duration, serviceInfo } = bookingSlot;
  
  const startTime = moment(start_time);
  const endTime = moment(end_time);
  const serviceStartTime = startTime;
  
  const activeItem = activeIndex === serviceIndex ? "bg-primary text-white" : "";
  const isDisabled = bookingSlot.status !== 'available';
  
  const handleClick = () => {
    if (!isDisabled) {
      onSelect(bookingSlot);
      setItem(serviceIndex);
      if (setSelectedServiceIndex) {
        setSelectedServiceIndex(serviceIndex);
      }
      if (executeScrollForm) {
        executeScrollForm();
      }
    }
  };

  return (
    <button
      disabled={isDisabled}
      className={`card mb-2 w-100 text-left ${activeItem} ${isDisabled ? "bg-grey text-muted" : ""}`}
      onClick={handleClick}
    >
      <div className="card-body">
        <h5 className="">{serviceInfo?.name}</h5>
        <small>
          {serviceStartTime.format("h:mm a")} -{" "}
          {serviceStartTime.clone().add(duration, "minutes").format("h:mm a")}
        </small>
      </div>
    </button>
  );
};

BookingSlotTimeButton.propTypes = {
  bookingSlot: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  serviceIndex: PropTypes.number,
  setItem: PropTypes.func,
  setSelectedServiceIndex: PropTypes.func,
  executeScrollForm: PropTypes.func,
  activeIndex: PropTypes.number,
  bookingItemTime: PropTypes.object,
};

export default BookingSlotTimeButton;
